import type { StoreActionApi } from 'react-sweet-state';
import { IntegrationProviderMeta } from '../../../../common/constants';
import type { ConnectionProviders, State, ConnectionStatus } from '../../../../common/types';
import { fetchConnectionStatus as getConnectionStatus } from '../../../services/fetch-connections';

export const fetchConnectionStatus =
    (cloudId: string) =>
    async ({ getState, setState }: StoreActionApi<State>) => {
        try {
            const data = await getConnectionStatus({ cloudId });
            const allowedIntegrations = Object.keys(IntegrationProviderMeta);
            const updatedConnectionStatusData = allowedIntegrations.reduce(
                (status: ConnectionStatus['data'], provider: ConnectionProviders) => {
                    status[provider] = data.find(
                        (item) =>
                            item.integrationId === IntegrationProviderMeta[provider].integrationId &&
                            item.type === IntegrationProviderMeta[provider].type
                    );
                    return status;
                },
                {} as ConnectionStatus['data']
            );

            setState({
                ...getState(),
                connectionStatus: {
                    ...getState().connectionStatus,
                    data: updatedConnectionStatusData,
                    isFetched: true,
                },
            });
        } catch {
            //need to add analytics

            setState({
                ...getState(),
                connectionStatus: {
                    ...getState().connectionStatus,
                    isFetched: false,
                },
            });
        }
    };
